import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";
import { ClaimFilters } from "./types";

export function useFetchClaims(filters: ClaimFilters, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      tenantDocumentNumber: filters.tenantDocumentNumber?.trim() || undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending } = useQuery({
    ...trpc.claims.list.queryOptions(queryInput),
    enabled: !!merchant?.id,
  });

  return {
    claims: data?.claims ?? [],
    nextCursor: data?.cursor || undefined,
    isLoading: isPending,
  };
}
